module.exports = __webpack_public_path__ + "media/images/doctor_default_square-0a7f0c728c09d10a4dde5010510ec2a4.png";